export default {
  // Navigation
  "nav.home": "Home",
  "nav.about": "About Us",
  "nav.services": "Services",
  "nav.contact": "Contact",
  "nav.lang": "Language",

  // Footer
  "footer.rights": "DEIASPART. All rights reserved.",
  "footer.address": "Avenida CDTE Gika n116, Alvalade, Maianga",
  "footer.followUs": "Follow Us",
  "footer.links": "Links",
  "footer.services": "Services",
  "footer.nif": "Tax ID",
  "footer.developedBy": "Developed and Maintained by:",

  // Home - Hero
  "home.hero.subtitle": "Engineering & Civil Construction",
  "home.hero.tagline": "Efficiency-oriented solutions since 2017",
  "home.hero.ctaServices": "Our Services",
  "home.hero.ctaContact": "Contact Us",
  "home.hero.slide2.title": "Perfect Solutions",
  "home.hero.slide3.title": "11 Services",
  "hero.carousel.prev": "Previous slide",
  "hero.carousel.next": "Next slide",
  "hero.carousel.goto": "Go to slide",

  // Home - About
  "home.about.title": "About DEIASPART",
  "home.about.text1": "DEIASPART is a company operating in the engineering and civil construction sector, in the areas of rehabilitation, installation, maintenance and technical assistance, management of condominiums and buildings.",
  "home.about.text2": "Founded in 2017, DEIASPART offers efficiency-oriented solutions where specific skills are valued, providing a set of integrated services that ensure the proper functioning of your facilities.",
  "home.about.cta": "Learn More",
  "home.about.since": "Since 2017",
  "home.about.location": "Luanda, Angola",

  // Home - Services
  "home.services.title": "Our Services",
  "home.services.subtitle": "Integrated skills for your project",
  "home.services.viewAll": "View All Services",
  "home.services.additionalTitle": "Additional Services",

  "service.mechanical.name": "Mechanical Lathe",
  "service.mechanical.desc": "Manufacturing of mechanical parts, nylon parts, motor winding and maintenance of metallurgical machines.",

  "service.electricity.name": "Electricity",
  "service.electricity.desc": "Installation and maintenance of electrical networks, generator repair, medium and low voltage installation.",

  "service.hydraulic.name": "Hydraulic",
  "service.hydraulic.desc": "Repair and maintenance of water networks, submersible pumps and water treatment systems.",

  "service.electromechanics.name": "Electromechanics",
  "service.electromechanics.desc": "Elevator and escalator maintenance, fire alarm systems, automatic air extractors and gates.",

  "service.hvac.name": "HVAC",
  "service.hvac.desc": "HVAC assembly and maintenance, air insufflation and pressurization systems, Schiller and VRV system repair.",

  "service.electronics.name": "Electricity & Electronics",
  "service.electronics.desc": "Electronic equipment repair, electric gate maintenance, CCTV and electronic security.",

  "service.tickets.name": "Flight Tickets",
  "service.tickets.desc": "Airline ticket booking for domestic and international destinations with personalized service.",

  "service.tourism.name": "Tourism",
  "service.tourism.desc": "Tourist packages and guided tours to discover the wonders of Angola and the world.",

  "service.office.name": "Office Supplies",
  "service.office.desc": "Supply of office materials and equipment for companies and individuals.",

  "service.visas.name": "Visa Processing",
  "service.visas.desc": "Complete assistance for obtaining travel, work and residence visas.",

  "service.rentacar.name": "Car Rental",
  "service.rentacar.desc": "Vehicle rental for individuals and companies with various fleet options.",

  // Home - Why Choose Us
  "home.why.title": "Why Choose DEIASPART?",
  "home.why.response": "Response Capacity",
  "home.why.responseDesc": "Correction, control, installation and operation management, validating the performance and quality of interventions.",
  "home.why.assistance": "24/7 Technical Assistance",
  "home.why.assistanceDesc": "Services scheduled according to our clients' availability, with 24/7 on-call service at no cost for emergency assistance services.",
  "home.why.experience": "Consolidated Experience",
  "home.why.experienceDesc": "More than 8 years of operation in the Angolan market, with solid references and satisfied customers.",

  // Home - Clients
  "home.clients.title": "Clients and Partners",
  "home.clients.subtitle": "Companies and organizations that trust DEIASPART",

  // Home - CTA
  "home.cta.title": "Ready to start your project?",
  "home.cta.subtitle": "Get in touch with us and request a free quote.",
  "home.cta.button": "Request a Quote",
  "home.cta.mailSubject": "Quote Request",

  // About page
  "about.hero.title": "About Us",
  "about.hero.subtitle": "Learn about the history and mission of DEIASPART",

  "about.story.title": "Our Story",
  "about.story.text1": "The DEIASPART group has been building a trajectory of ways to consolidate in a sustainable way its reference and economy, in the activities of Maintenance and Technical Assistance in the various areas of Engineering and Restoration.",
  "about.story.text2": "We have made a path with ambition and determination aiming at our goals and offering the best services. We are focused on achieving good results and improving our position in the market in which we operate, keeping the focus on overcoming barriers, innovating and providing optimism to our way of thinking and acting.",

  "about.mission.title": "Mission",
  "about.mission.text": "To offer efficiency-oriented solutions where specific skills are valued, providing a set of integrated services that ensure the proper functioning of our clients' facilities.",

  "about.vision.title": "Vision",
  "about.vision.text": "To be a national reference in engineering and civil construction, recognized for quality, innovation and commitment to customer satisfaction.",

  "about.values.title": "Values",
  "about.values.integrity": "Integrity",
  "about.values.integrityDesc": "We act with ethics, transparency and responsibility in all our relationships.",
  "about.values.excellence": "Excellence",
  "about.values.excellenceDesc": "We are committed to superior quality and continuous improvement of our services.",
  "about.values.innovation": "Innovation",
  "about.values.innovationDesc": "We adopt new technologies and methods to offer increasingly efficient solutions.",
  "about.values.commitment": "Commitment",
  "about.values.commitmentDesc": "We meet our deadlines and guarantee total customer satisfaction.",

  "about.stats.years": "Years of Experience",
  "about.stats.services": "Services",
  "about.stats.clients": "Satisfied Clients",
  "about.stats.support": "24/7 Support",

  // Services page
  "services.hero.title": "Our Services",
  "services.hero.subtitle": "Integrated engineering solutions and additional services",

  "services.engineering.title": "Engineering Services",
  "services.engineering.desc": "Provision of specialized technical services in the various areas of engineering, with qualified teams and quality materials.",

  "services.additional.title": "Additional Services",
  "services.additional.desc": "Complementary services to make our clients' lives easier, from travel to office logistics.",

  "services.cta.text": "Need any of these services?",
  "services.cta.button": "Contact Us Now",
  "services.card.request": "Request",

  "services.detail.mechanical": "Manufacturing of custom mechanical parts, manufacturing of nylon parts for various industrial applications, rewinding of electric motors and maintenance of metallurgical machines.",
  "services.detail.electricity": "Installation and maintenance of electrical networks in residential and commercial buildings, maintenance and repair of generators, medium and low voltage installations, assembly and reading of electrical schematics, installation of sockets, switches and distribution panels.",
  "services.detail.hydraulic": "Repair and maintenance of drinking water and sewage networks, maintenance of submersible pumps, installation of water treatment systems for human and industrial consumption, and construction of specialized teams.",
  "services.detail.electromechanics": "Preventive and corrective maintenance of elevators and escalators, installation and maintenance of fire alarm and detection systems (SADI), automatic air extractors for industrial and domestic environments, air pressurization systems, and installation and maintenance of automatic gates.",
  "services.detail.hvac": "Assembly and maintenance of HVAC systems (Heating, Ventilation and Air Conditioning), air insufflation and pressurization systems for commercial and industrial buildings, repair of Schiller and VRV (Variable Refrigerant Volume) systems.",
  "services.detail.electronics": "Repair of various electronic equipment, maintenance of electric gates and turnstiles, installation and maintenance of CCTV and electronic security systems.",
  "services.detail.tickets": "Airline ticket booking for domestic and international destinations. Personalized service to find the best flight options at the best prices.",
  "services.detail.tourism": "Organization of tourist packages and guided tours to explore the beauties of Angola and international destinations. Memorable experiences with professional guides.",
  "services.detail.office": "Supply of office materials including stationery, furniture, computer equipment and consumables for companies and individuals.",
  "services.detail.visas": "Complete assistance in the process of obtaining travel, work and residence visas. Documentary follow-up and support in all phases of the process.",
  "services.detail.rentacar": "Rental of passenger and commercial vehicles for individuals and companies. Diversified fleet with short and long term options.",

  // Contact page
  "contact.hero.title": "Contact",
  "contact.hero.subtitle": "We are ready to help you. Get in touch with us.",

  "contact.info.title": "Contact Information",
  "contact.info.address": "Address",
  "contact.info.addressValue": "Avenida CDTE Gika n116, Alvalade, Maianga, Luanda, Angola",
  "contact.info.phones": "Phones",
  "contact.info.emails": "Emails",
  "contact.info.nif": "Tax ID",

  "contact.services.title": "Request Service by Email",
  "contact.services.subtitle": "Click on the desired service to send us an email",
  "contact.services.emailSubject": "Service Request - ",

  "contact.cta.title": "Prefer to talk to us?",
  "contact.cta.text": "Our team is available to assist you. Contact us by phone or email and we will respond as soon as possible.",

  // Common
  "common.readMore": "Read More",
  "common.send": "Send",
  "common.sending": "Sending...",
  "common.success": "Message sent successfully!",
  "common.error": "An error occurred. Please try again.",
  "common.required": "Required field",
  "common.emailInvalid": "Invalid email",
  "common.phone": "Phone",
  "common.email": "Email",
  "common.name": "Name",
  "common.message": "Message",
  "common.close": "Close",
};